import Rsvps from '../../../store/rsvps';

angular
    .module('festzelt-os.guestlists')
    .factory('Rsvps', [
        '$injector',
        'Rsvp',
        ($injector, Rsvp) => {
            return {
                create(name) {
                    return new Rsvps(name, Rsvp, {
                        injector: $injector
                    })
                }
            }
        }
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/store/rsvps.js